// @flow
import styled from "styled-components";
import { media } from "@nested/brand";
import { blogWrapperStyles } from "../../../components/Blog/Breadcrumbs";

const Wrapper = styled.div`
  text-align: center;
  margin: 50px auto;
  max-width: 590px;
`;

const Image = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  ${media.tablet`
    margin-top: 0px;
    margin-bottom: 0px;
    display: inline-block;
    vertical-align: top;
    width: calc(
      100% / ${({ items }) => items} - 50px * (${({ items }) => items} - 1) /
        ${({ items }) => items}
    );
    &:not(:last-child) {
      margin-right: 50px;
    }
  `};
`;

const Img = styled.img`
  display: block;
  width: 100%;
`;

const Caption = styled.h6`
  margin-top: 20px;
  margin-bottom: 40px;
  text-align: left;

  ${media.tablet`
    margin-bottom: 0px;
  `};
`;

type Props = {
  repeat: {
    caption?: string,
    image: PrismicImageConfig,
  }[],
};

const ImageGallery = ({ repeat }: Props) => (
  <div css={blogWrapperStyles}>
    <Wrapper>
      {repeat.map((item, index) => (
        <Image key={index} items={repeat.length}>
          <Img src={item.image.url} />
          {item.caption && <Caption>{item.caption}</Caption>}
        </Image>
      ))}
    </Wrapper>
  </div>
);

export { ImageGallery };
